import $ from 'jquery'

export default class UIHelper {
  static highlightEl(el, callback) {
    if(el){
      $(el).css('box-shadow', '0 0 7px 0 rgba(25,145,245,1)');
      this.fadeOut(el, callback);
    }
  }

  static fadeOut(el, callback) {
    if(el){
      $({alpha:1}).animate({alpha:0}, {
        duration: 4000,
        step: function(){
          $(el).css('box-shadow', '0 0 7px 0 rgba(25,145,245,' + this.alpha + ')');
        },
        complete: () => {
          $(el).css('box-shadow', 'none')
          callback && callback()
        }
      });
    }
  }
}
